import { CompanyInfo } from '../types';

export const COMPANY_INFO: CompanyInfo = {
  name: 'EZTECH SOLUTIONS',
  siren: '983 121 203',
  siret: '98312120300035',
  address: {
    street: '91 Avenue de la Châtaigneraie',
    city: 'Rueil-Malmaison',
    postalCode: '92500',
    country: 'France',
  },
  manager: 'Zakaria El Gharmaoui',
  foundedDate: '04/01/2024',
};

export const SERVICES_LIST = [
  {
    id: 'conseil',
    title: 'Conseil Informatique',
    description: 'Analyse et optimisation de vos systèmes d\'information pour une meilleure performance',
    features: ['Audit informatique', 'Architecture système', 'Transformation digitale'],
  },
  {
    id: 'developpement',
    title: 'Développement Logiciel',
    description: 'Applications web et mobiles sur mesure avec les dernières technologies',
    features: ['Applications web', 'Applications mobiles', 'API et intégrations'],
  },
  {
    id: 'bi',
    title: 'Business Intelligence',
    description: 'Transformez vos données en insights stratégiques pour votre entreprise',
    features: ['Tableaux de bord', 'Analyse prédictive', 'Reporting automatisé'],
  },
  {
    id: 'data',
    title: 'Data Science',
    description: 'Exploitez le potentiel de vos données avec l\'intelligence artificielle',
    features: ['Machine Learning', 'Analyse de données', 'Modèles prédictifs'],
  },
  {
    id: 'cloud',
    title: 'Infrastructure Cloud',
    description: 'Migration et sécurisation de vos infrastructures vers le cloud',
    features: ['Migration cloud', 'Sécurité renforcée', 'Optimisation des coûts'],
  },
  {
    id: 'formation',
    title: 'Formation',
    description: 'Formations personnalisées pour maîtriser les nouvelles technologies',
    features: ['Formation technique', 'Ateliers pratiques', 'Accompagnement'],
  },
  {
    id: 'cybersecurite',
    title: 'Cybersécurité',
    description: 'Protégez vos systèmes et données contre les menaces avec nos experts certifiés',
    features: ['Audit de sécurité', 'Tests de pénétration', 'Conformité RGPD'],
  },
];

export interface Mission {
  id: string;
  title: string;
  sector: string;
  category: string;
  description: string;
  technologies: string[];
  results?: string;
}

export const MISSIONS_LIST: Mission[] = [
  {
    id: 'direction-technique',
    title: 'Direction Technique & R&D',
    sector: 'Startup Tech',
    category: 'conseil',
    description: 'Direction technique complète : pilotage des développements, stratégie R&D, gestion d\'équipe. Évaluation de prototypes, rapports de développement et relations partenaires.',
    technologies: ['React', 'Node.js', 'Azure', 'GCP', 'Docker', 'Kubernetes'],
  },
  {
    id: 'cybersecurite',
    title: 'Cybersécurité & Sécurisation',
    sector: 'PME & Grandes Entreprises',
    category: 'cybersecurite',
    description: 'Audits de sécurité, tests d\'intrusion (pentest), sécurisation des infrastructures Cloud et réseaux. Accompagnement ISO 27001, conformité RGPD et veille cybersécurité.',
    technologies: ['Pentest', 'Burp Suite', 'Kali Linux', 'OWASP', 'ISO 27001'],
  },
  {
    id: 'securisation-infra',
    title: 'Sécurisation des Infrastructures',
    sector: 'Tous Secteurs',
    category: 'cybersecurite',
    description: 'Hardening serveurs et postes, configuration pare-feu, segmentation réseau, gestion des accès (IAM), chiffrement des données et mise en place de politiques de sécurité.',
    technologies: ['Pare-feu', 'IAM', 'Azure AD', 'Cryptage', 'SIEM'],
  },
  {
    id: 'ia-data',
    title: 'IA & Data Science',
    sector: 'Entreprises',
    category: 'data',
    description: 'Développement de solutions IA : modèles de machine learning, intégration de LLMs, analyse prédictive et automatisation intelligente des processus métiers.',
    technologies: ['Python', 'TensorFlow', 'PyTorch', 'LLMs', 'Power BI'],
  },
  {
    id: 'donnees-sante',
    title: 'Gestion de Données Sensibles',
    sector: 'Secteur Santé',
    category: 'cloud',
    description: 'Administration de données de santé (HDS), données clients et personnelles. Anonymisation, pseudonymisation, cryptage et contrôle d\'accès conformes RGPD.',
    technologies: ['Azure', 'SQL Server', 'RGPD', 'Cryptage', 'IAM'],
  },
  {
    id: 'transformation-digitale',
    title: 'Transformation Digitale',
    sector: 'Grandes Organisations',
    category: 'conseil',
    description: 'Déploiement Agile Scrum, intégration d\'écosystèmes SaaS (RH, CRM, comptabilité, logistique). Développement d\'API sur mesure et automatisation.',
    technologies: ['Azure DevOps', 'API REST', 'Power Apps', 'Scrum'],
  },
  {
    id: 'plateforme-web',
    title: 'Développement de Plateformes Web',
    sector: 'Startups & Entreprises',
    category: 'developpement',
    description: 'Conception et développement de plateformes web complètes : frontend React/Angular, backend Node.js/Express, API Strapi, design Figma.',
    technologies: ['React', 'Node.js', 'Express', 'Strapi', 'Figma'],
  },
  {
    id: 'ecommerce',
    title: 'Solutions E-Commerce',
    sector: 'Commerce & Retail',
    category: 'developpement',
    description: 'Création de boutiques en ligne, pages de vente, configuration paiements et intégration logistique.',
    technologies: ['Prestashop', 'Shopify', 'Stripe', 'PayPal'],
  },
  {
    id: 'apps-metier',
    title: 'Applications Métier',
    sector: 'Entreprises & Associations',
    category: 'developpement',
    description: 'Applications internes : CRM, circuits d\'inscription bénévoles, gestion d\'événements. Automatisation workflows et tableaux de bord.',
    technologies: ['Power Apps', 'Power BI', 'React', 'SQL Server'],
  },
  {
    id: 'infra-reseau',
    title: 'Infrastructure IT & Réseaux',
    sector: 'PME & Associations',
    category: 'cloud',
    description: 'Gestion complète : déploiement fibre, pare-feu, administration réseau, gestion du parc IT (PC, mobiles, serveurs). Support quotidien.',
    technologies: ['Réseau', 'Pare-feu', 'Windows Server', 'MDM'],
  },
  {
    id: 'hebergement',
    title: 'Hébergement & Administration',
    sector: 'Tous Secteurs',
    category: 'cloud',
    description: 'Hébergement et administration de sites web et plateformes. Déploiement, maintenance, sauvegardes, certificats SSL et monitoring de performance.',
    technologies: ['Azure', 'Docker', 'Nginx', 'SSL', 'CI/CD'],
  },
  {
    id: 'systemes-embarques',
    title: 'Systèmes Embarqués & Électronique',
    sector: 'Industrie & R&D',
    category: 'developpement',
    description: 'Développement pour microcontrôleurs (STM32, Arduino, Raspberry Pi, PSOC). Asservissement numérique, correcteurs PID et prototypage.',
    technologies: ['STM32', 'Arduino', 'Raspberry Pi', 'C/C++', 'MATLAB'],
  },
  {
    id: 'formations',
    title: 'Formations & Enseignement',
    sector: 'Enseignement & Entreprises',
    category: 'data',
    description: 'Formations Python, développement web, systèmes embarqués, mathématiques pour data science/cybersécurité. Initiation au code et robotique.',
    technologies: ['Python', 'React', 'STM32', 'Data Science'],
  },
  {
    id: 'impact-social',
    title: 'Projets à Impact Social',
    sector: 'Partenariats Grands Comptes',
    category: 'developpement',
    description: 'Programmes d\'initiation au code et robotique pour publics spécifiques. Développement de supports pédagogiques adaptés en partenariat avec grands groupes.',
    technologies: ['Python', 'Scratch', 'Robotique', 'Pédagogie'],
  },
];

export const TECHNOLOGIES = {
  frontend: ['React', 'Angular', 'TypeScript', 'Flutter', 'Bootstrap', 'Figma'],
  backend: ['Node.js', 'Python', 'Express.js', 'PHP/Laravel', 'SQL Server', 'MongoDB'],
  cloud: ['Microsoft Azure', 'Google Cloud', 'Docker', 'Kubernetes', 'Terraform', 'Azure DevOps'],
  data: ['LLMs / IA Générative', 'Python', 'TensorFlow', 'PyTorch', 'Power BI', 'Data Science'],
  security: ['Pentest', 'Burp Suite', 'Kali Linux', 'OWASP', 'ISO 27001', 'RGPD'],
  tools: ['Git', 'Power Apps', 'Office 365', 'Jira', 'Scrum', 'Prestashop / Shopify'],
};